module.exports = __webpack_public_path__ + "img/7.b37d9ef2.jpg";